module.exports = __webpack_public_path__ + "static/media/icone_nere.74ba50c1.svg";